<div class="page-container carrier-portal-container container">
  <div class="row w-100 m-0">
    <app-utility-toolbar
      class="{{ navCollapsed ? 'w-5' : 'w-15' }} vertical"
      [current]="current"
      [vertical]="true"
      [links]="bmLinks"
      (toggleCollapse)="toggleNavCollapse()"
    />

    <div class="content-container pl-3" [ngClass]="{ collapsed: navCollapsed }">
      @if (current === 'carrier-portal') {
        <h1 class="header col-12 mb-2"> Carrier Partner Portal </h1>

        <app-bm-widget-filters
          [viewMode]="'carrier'"
          [minDate]="minDate"
          [defaultRange]="'30 days'"
          [preexistingWidgetFilters]="preexistingWidgetFilters"
        />

        <div class="home-office-container">
          <div class="row">
            <app-contract-stats
              class="col-12"
              [reportName]="'PM Carrier Contract Totals'"
            />
          </div>

          @if (rights?.includes('PMCarrierPolicyDrilldown')) {
            <div class="row">
              <app-policy-drilldown
                class="col-12"
                [view]="'carrier'"
                (emitDrilldownFilter)="emitDrilldownFilter($event)"
              />
            </div>
          }
          @if (rights?.includes('PMCarrierPolicySummaryGroupBy')) {
            <div class="row">
              <app-contract-summary
                class="col-12"
                [reportName]="'PM Carrier Contract Summary'"
                [headerType]="'carrier'"
              />
            </div>
          }

          <div class="row">
            <app-top-performers
              class="col-12"
              [title]="'Top Performers'"
              [configType]="'carrier-top-performers'"
              [reportName]="'PM Carrier Top Performers'"
            />
          </div>
        </div>
      } @else if (current === 'carrier-policy-details') {
        <app-carrier-policy-details />
      }
    </div>
  </div>
</div>
